function Select({
    label = defaultValues.label,
    options = defaultValues.options,
    changeEvent = defaultValues.changeEvent,
    id = defaultValues.id,
    generalClass = defaultValues.generalClass,
    classLeft = defaultValues.classLeft,
    classRight = defaultValues.classRight
}) {
  return (
    <div className={generalClass}>
        <div className={classLeft}>
            <label><strong>{label} :</strong></label>
        </div>
        <div className={classRight}>
            <select onChange={changeEvent} id={id}>
                {options.map((item) => (
                    <option value={item.value} key={item.id}>{item.text}</option>
                ))}
            </select>
        </div>
    </div>
  )
}

const emptyFunction = () => {}

const defaultValues = {
    label: 'Example',
    options: [{id: 0, name: 'Option 1'}, {id: 1, name: 'Option 2'}, {id: 2, name: 'Option 3'}],
    changeEvent: emptyFunction,
    id: 'defaultSelect',
    generalClass: 'doubleColumnBenefit',
    classLeft: 'leftColumn',
    classRight: 'rightColumn'
}

export default Select